export class Draw {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Draw";
    this.scene = "Draw";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    this.data.push({
      name: "Topline",
      value: {
        text: options.topline || "",
      },
    });

    this.data.push({
      name: "Bottomline",
      value: {
        text: options.bottomline || "",
      },
    });

    this.data.push({
      name: "Logo Visible",
      value: {
        text: options.logoVisible
      },
    });

    for (let i = 1; i <= 4; i++) {
      this.data.push({
        name: "GRP" + i + "Team_1",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_1")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_2",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_2")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_3",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_3")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_4",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_4")
              ?.team?.name || "",
        },
      });
    }

    this.sendPreview(this.scene, 500, this.data, "IN");

  }

  update({ options }) {

    this.data.push({
      name: "Topline",
      value: {
        text: options.topline || "",
      },
    });

    this.data.push({
      name: "Bottomline",
      value: {
        text: options.bottomline || "",
      },
    });

    this.data.push({
      name: "Logo Visible",
      value: {
        text: options.logoVisible
      },
    });

    for (let i = 1; i <= 4; i++) {
      this.data.push({
        name: "GRP" + i + "Team_1",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_1")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_2",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_2")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_3",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_3")
              ?.team?.name || "",
        },
      });
      this.data.push({
        name: "GRP" + i + "Team_4",
        value: {
          text:
            options?.groups?.find((g) => g.group === "group_" + i + "_slot_4")
              ?.team?.name || "",
        },
      });
    }
    this.sendUpdate(this.scene, this.data);
  }
   animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
   animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
